var React = require('react');

function VideoAds (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.66667 0.5C1.02233 0.5 0.5 1.02233 0.5 1.66667V2.83333H14.5V1.66667C14.5 1.02233 13.9777 0.5 13.3333 0.5H1.66667Z","fill":"#6366F1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 4H0.5V11H14.5V4ZM9.65224 7.77835C9.8937 7.65528 9.8937 7.34472 9.65224 7.22165L5.70439 5.20938C5.46479 5.08725 5.16667 5.24157 5.16667 5.48773V9.51227C5.16667 9.75843 5.46479 9.91275 5.70439 9.79062L9.65224 7.77835Z","fill":"#6366F1","key":1}),React.createElement("path",{"d":"M0.5 12.1667H14.5V13.3333C14.5 13.9777 13.9777 14.5 13.3333 14.5H1.66667C1.02233 14.5 0.5 13.9777 0.5 13.3333V12.1667Z","fill":"#6366F1","key":2})]);
}

VideoAds.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = VideoAds;

VideoAds.default = VideoAds;
